import { Toaster } from "@/components/ui/toaster"
import { Toaster as Sonner } from "@/components/ui/sonner"
import { TooltipProvider } from "@/components/ui/tooltip"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { Routes, Route, Navigate } from "react-router-dom"

import AdminDashboard from "@/admin/pages/AdminDashboard"
import NotFound from "../user/pages/NotFound"
import Footer from "../components/Footer"
import AdminBookingHistory from "@/admin/pages/AdminBookingHistory"
import AdminBookingConfirmation from "@/admin/pages/AdminBookingConfirmation"
import AdminLogin from "@/admin/pages/AdminLogin"
import ManualBlockingHistoryPage from "@/admin/pages/ManualBlockingHistoryPage"

const queryClient = new QueryClient()

const AdminApp = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <div className="flex flex-col min-h-screen">
          <div className="flex-grow">
            <Routes>
              <Route
                path="/"
                element={<Navigate to="/admin-login" replace />}
              />
              <Route path="/admin-login" element={<AdminLogin />} />
              <Route path="/admin-dashboard" element={<AdminDashboard />} />
              <Route
                path="/manual-blocking-history"
                element={<ManualBlockingHistoryPage />}
              />
              <Route
                path="/admin/booking-history"
                element={<AdminBookingHistory />}
              />
              <Route
                path="/admin/booking-confirmation"
                element={<AdminBookingConfirmation />}
              />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
          <Footer />
        </div>
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default AdminApp